// src/components/institution/modals/EventDetailsModal.jsx
import React from 'react';
import { X, Calendar, Clock, MapPin, Users } from 'lucide-react';

export const EventDetailsModal = ({ event, onClose, styling }) => {
  if (!event) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    return new Date(`1970-01-01T${timeString}`).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">{event.title}</h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6">
          {event.image && (
            <img 
              src={event.image} 
              alt={event.title}
              className="w-full h-64 object-cover rounded-lg mb-6"
            />
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="flex items-center gap-3">
              <Calendar className="h-5 w-5 text-indigo-600" />
              <div>
                <div className="text-sm text-gray-500">Date</div>
                <div className="font-medium">{formatDate(event.eventDate)}</div>
              </div>
            </div>

            {event.eventTime && (
              <div className="flex items-center gap-3">
                <Clock className="h-5 w-5 text-indigo-600" />
                <div>
                  <div className="text-sm text-gray-500">Time</div>
                  <div className="font-medium">{formatTime(event.eventTime)}</div>
                </div>
              </div>
            )}

            {event.location && (
              <div className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-indigo-600" />
                <div>
                  <div className="text-sm text-gray-500">Location</div>
                  <div className="font-medium">{event.location}</div>
                </div>
              </div>
            )}
          </div>

          {event.description && (
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">About this Event</h3>
              <div className="text-gray-600 whitespace-pre-wrap">{event.description}</div>
            </div>
          )}

          {event.maxAttendees && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Users className="h-5 w-5 text-gray-600" />
                  <span className="font-medium">Attendance</span>
                </div>
                <div className="text-sm text-gray-600">
                  {event.attendeeCount || 0} / {event.maxAttendees} registered
                </div>
              </div>
            </div>
          )}

          {event.requireRegistration && (
            <div className="text-center">
              <button
                style={{ backgroundColor: styling?.primaryColor || '#4f46e5' }}
                className="text-white px-8 py-3 rounded-lg hover:opacity-90 font-medium"
              >
                Register for Event
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};